import loadable from "@loadable/component";
import React from "react";

import useStaticContext from "@hooks/useStaticContext";
import useConstants from "@hooks/useConstants";

import Header from "@components/Main/Shared/Header";
import Footer from "@components/Main/Shared/Footer";

import ProBanner from "./ProBanner";
import ProPitch from "./ProPitch";
import ProBannerAlternate from "./ProBannerAlternate";
import ProHowItWorks from "./ProHowItWorks";
import ProBar from "./ProBar";
import ProCategories from "./ProCategories";
import ProFooter from "./ProFooter";
import ProReview from "./ProReview";
import ProFAQ from "./ProFAQ";
import ProLatestLeads from "./ProLatestLeads";
import ProPricing from "./ProPricing";

import SignUpFunnel from "@components/Main/Shared/ProSignupFunnel";
import ProStats from "./ProStats";
import ProJobTypes from "@components/Main/Pro/ProJobTypes";
import ProComparison from "./ProComparison";
import ProSplash from "./ProSplash";

const Pro = () => {
	const { services, categories, app } = useStaticContext();

	const { city, state } = app.location || {};

	const {
		showTutoringJobs,
		showPitch,
		showCategories,
		showFAQ,
		showLatestLeads,
		showHowItWorks,
		showAlternateBanner,
		showProFooter,
		showPricing,
		showStats,
		showComparison,
		showSplash,
	} = useConstants("ProViewModel");

	return (
		<React.Fragment>
			<Header searchBar={false} />
			{showAlternateBanner ? (
				<ProBannerAlternate city={city} state={state} />
			) : (
				<ProBanner services={services} city={city} state={state} />
			)}
			{showHowItWorks && <ProHowItWorks />}

			{showLatestLeads && <ProLatestLeads />}

			{showPitch && <ProPitch />}

			{showSplash && <ProSplash />}

			{showComparison && <ProComparison />}

			{showPricing && <ProPricing />}

			{showStats && <ProStats />}

			<ProReview />

			{showCategories && <ProCategories categories={categories} />}

			{showFAQ && <ProFAQ />}

			{showProFooter && <ProFooter />}

			{showTutoringJobs && <ProJobTypes />}
			<ProBar />
			<SignUpFunnel />
			<Footer />
		</React.Fragment>
	);
};

export default Pro;

export const loader = (route) =>
	loadable(() => import("./Pro.component"), { ssr: !!route.ssr });
